import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArSY: CultureInfo = {
  name: 'ar-SY',
  displayName: 'Arabic (Syria)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-SY',
  parent: CultureInfoAr
};
